interface BuilderWordmarkProps {
  theme?: "light" | "dark";
}

/**
 * Brandowy lockup: kafelek ochre z literą "B" + słowo "Builder".
 * theme="dark"  → tekst #F2EDE3 (na ciemnym tle sidebara)
 * theme="light" → tekst #14120D (na jasnym tle, np. login)
 */
export function BuilderWordmark({ theme = "light" }: BuilderWordmarkProps) {
  const textColor = theme === "dark" ? "#F2EDE3" : "#14120D";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.35em",
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "1.04em",
          height: "1.04em",
          borderRadius: "0.25em",
          background: "#C7541F",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontFamily: '"Bricolage Grotesque", sans-serif',
            fontWeight: 800,
            color: "#F2EDE3",
            fontSize: "0.72em",
            lineHeight: 1,
            letterSpacing: 0,
          }}
        >
          B
        </span>
      </span>
      <span
        style={{
          fontFamily: '"Bricolage Grotesque", sans-serif',
          fontWeight: 700,
          letterSpacing: "-0.035em",
          color: textColor,
        }}
      >
        Builder
      </span>
    </span>
  );
}
